import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { DisplayNames, FieldsForAdditionalDetails, RecordTypesInExpectedOrder, RequestedRecordTypes, TypesOfImaging, TypesOfImagingInExpectedOrder } from './records.model';
import { DatePickerModule } from 'primeng/datepicker';
import { ModalComponent } from '../../shared/modal/modal.component';
import _ from 'lodash';
import { DropdownModule } from 'primeng/dropdown';
import { CustomFormControl } from '../../shared/shared.model';
import { ssnSubjectMismatchValidator } from './ssnSubjectValidator';
import { VocabHelperService } from '../../services/vocab-helper/vocab-helper.service';
import { InputMaskModule } from 'primeng/inputmask';
import { DateMaskDirective } from '../../shared/directive/date-mask.directive';
import { SanitizePasteDirective } from '../../shared/directive/sanitize-paste.directive';
import { AttachmentsComponent } from '../../shared/components/attachments/attachments.component';
import { DocumentProcessingService } from '../../services/document-processor/document-processor.service';
import { AttachmentProcessorService } from '../place-order/attachment.processor.service';
import { Attachment } from '../../order-info/order-info.model';
import { CleanStepPanelAccessibilityDirective } from '../../order-info/accesibility.directive';
import { MessageService } from 'primeng/api';
import { ContactSearchComponent } from './contact-search/contact-search.component';
import { ContactItem, PartyName, PartyLocator } from 'com.trumbull.phx.contactlist.api-client';
import { FeatureService, FeatureFlagState } from 'com.trumbull.phx.feature.api-client';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { ExternalUserCheckService } from '../../services/external-user-check-service/external-user-check-service.service';
import { CreateUuidService } from '../../services/create-uuid/create-uuid.service';


@Component({
  selector: 'app-records',
  imports: [InputTextModule, CommonModule,
    ReactiveFormsModule, SelectModule, PanelModule, CardModule, CleanStepPanelAccessibilityDirective,
    CheckboxModule, ButtonModule, TextareaModule, DatePickerModule, FormsModule, ModalComponent, DropdownModule, InputMaskModule, DateMaskDirective, AttachmentsComponent, ContactSearchComponent, SanitizePasteDirective],
  templateUrl: './records.component.html',
  styleUrl: './records.component.scss'
})
export class RecordsComponent implements OnDestroy {
  @ViewChild('stepHeading') stepHeading!: ElementRef;
  @ViewChildren('recordsHeaders') recordsHeaders!: QueryList<ElementRef>;

  @Input() formData: any;
  @Input() subjects: any;
  @Input() selectedCategory: any;
  @Input() states: Array<{ name: string; value: string }> = [];
  @Input() editOrder: any;
  @Input() vocabDocumentTagsData: any;
  @Output() formChanged = new EventEmitter<void>();
  @Output() addProviderValidate = new EventEmitter<void>();

  recordsFormGroup!: FormGroup;
  // states = states;
  typesOfImaging = TypesOfImaging;
  selectedTemplates: string[] = [];
  requestedRecordTypes = RequestedRecordTypes;
  selectedRecordTypes: string[] = [];
  displayNames = DisplayNames;
  showDeleteModal: boolean = false;
  itemToDelete: any;
  maxDate: Date = new Date();
  records: FormArray;
  attachments: any[] = [];
  isRequestDocumentsLoading: boolean = true;
  requestDocuments: { requestNumber: string; documentList: Attachment[] }[] = [];
  isSearchProviderEnabled: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(private readonly vocabService: VocabHelperService, private fb: FormBuilder, private cdr: ChangeDetectorRef, private readonly attachmentProcessorService: AttachmentProcessorService, private readonly documentProcessor: DocumentProcessingService,  private messageService: MessageService, private featureService: FeatureService, private readonly externalUserCheckService: ExternalUserCheckService, private readonly createUuidService: CreateUuidService) {
    this.records = this.fb.array([this.createRecordsFormGroup()]);
    this.recordsFormGroup = this.fb.group({
      records: this.records
    }, {
      validators: [ssnSubjectMismatchValidator(this.records)]
    });
  }

  isRangeSelected: boolean = true;
  fieldsForAdditionalDetails = FieldsForAdditionalDetails;
  subjectNames: string[] = [];
  recordTypesInExpectedOrder = RecordTypesInExpectedOrder;
  typesOfImagingInExpectedOrder = TypesOfImagingInExpectedOrder;

  /**
   * Initializes the component, sets up form controls, and processes the subject data.
   */
  ngOnInit(): void {
    this.evaluateSearchProviderVisibility();
    if(this.formData) {
      this.initializeFormData();
    }
    if (this.subjects) {
      let nameList = _.map(_.get(this.subjects, 'subjects'), 'recordSubjectName');
      if (nameList && !_.isNull(nameList[0])) {
        this.subjectNames = nameList;
        this.subjectNames.length === 1 ? this.records.controls[0].get('subject')?.setValue(this.subjectNames[0]) : this.records.controls[0].get('subject')?.setValue('');
      }
    }

    this.vocabService.getVocabData(['RecordTypes', 'ImagingTypes', 'VA_Options']).subscribe(data => {
      if (data) {
        const vocabRecordTypesData = data.find(d => d.vocabularyName === 'RecordTypes');
        if (vocabRecordTypesData) {
          this.requestedRecordTypes = vocabRecordTypesData.vocabularyItems.map(item => ({ name: item.description, key: item.code }));
          this.sortRecordsInExpectedOrder();
        }
        const vocabImagingTypesData = data.find(d => d.vocabularyName === 'ImagingTypes');
        if (vocabImagingTypesData) {
          this.typesOfImaging = vocabImagingTypesData.vocabularyItems.map(item => ({ name: item.description, code: item.code }));
        }
        this.getSortedDiagnosticList(this.typesOfImaging);
      }
      this.setupValidation();
    });
      this.processAttachments();

    // this.sortRecordsInExpectedOrder();
    // this.getSortedDiagnosticList(this.typesOfImaging);

    this.recordsFormGroup.valueChanges.subscribe(() => {
      this.formChanged.emit();
    });
  }

  // add focus to the top header
  ngAfterViewInit() {
    setTimeout(() => {
      this.stepHeading.nativeElement.focus();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Evaluates search provider visibility based on feature flags and user account linkage.
   *
   * This method determines whether the provider search functionality should be enabled for the current user
   * by evaluating two feature flags:
   *
   * Feature Flags:
   * 1. SearchProviderEnabled (search.provider):
   *    - 'Y': Provider search functionality is enabled
   *    - 'N': Provider search functionality is disabled for all users
   *
   * 2. SearchProviderVisibility (search.provider):
   *    - 'all': Provider search is available for all users (internal and external)
   *    - 'external': Provider search is available only for external/linked account users
   *    - 'internal': Provider search is available only for internal users (not linked to account)
   *    - 'none': Provider search is not available to any user
   *
   * Decision Logic:
   *    The provider search is enabled only when ALL of the following conditions are met:
   *    - SearchProviderEnabled is 'Y' AND
   *    - SearchProviderVisibility matches the user's account type:
   *      * visibility === 'all' (for all users), OR
   *      * visibility === 'external' AND user is linked to an account (external user), OR
   *      * visibility === 'internal' AND user is NOT linked to an account (internal user)
   *
   * Example Configurations:
   *    - SearchProviderEnabled=Y, SearchProviderVisibility=all → Enabled for all users
   *    - SearchProviderEnabled=Y, SearchProviderVisibility=external → Enabled for external users only
   *    - SearchProviderEnabled=Y, SearchProviderVisibility=internal → Enabled for internal users only
   *    - SearchProviderEnabled=N, SearchProviderVisibility=* → Disabled for all users (any visibility)
   */
  private evaluateSearchProviderVisibility(): void {
    forkJoin([
      this.featureService.getFeatureFlag('search.provider', 'SearchProviderEnabled'),
      this.featureService.getFeatureFlag('search.provider', 'SearchProviderVisibility'),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([enabledFlag, visibilityFlag]) => {
        const isSearchProviderEnabled = enabledFlag.value === 'Y';
        const searchProviderVisibility = visibilityFlag.value;
        const isUserLinkedToAccount = this.isUserLinkedToAccount();

        this.isSearchProviderEnabled = this.evaluateVisibility(
          isSearchProviderEnabled,
          searchProviderVisibility,
          isUserLinkedToAccount
        );
      });
  }

  private isUserLinkedToAccount(): boolean {
    return this.externalUserCheckService.isExternalUser();
  }

  private evaluateVisibility(
    isEnabled: boolean,
    visibility: string | undefined,
    isLinked: boolean
  ): boolean {
    return !!(
      isEnabled &&
      visibility &&
      (visibility === 'all' ||
        (visibility === 'external' && isLinked) ||
        (visibility === 'internal' && !isLinked))
    );
  }

  getRequestDocuments(index: any){
    if(this.requestDocuments && this.requestDocuments[index]?.documentList) {
      return this.requestDocuments[index]?.documentList;
    } else {
      return [];
    }
  }

  processAttachments() {
    this.isRequestDocumentsLoading = this.editOrder;
    this.requestDocuments = this.attachmentProcessorService.getRequestDocuments();
    if (this.requestDocuments?.length) {
          this.initializeFormData();
        this.isRequestDocumentsLoading = false;

        this.setupValidation();
      return;
  }
    let requests = this.attachmentProcessorService.getRequests();
    this.attachmentProcessorService.getMatchedDocumentsForRequests(requests, this.vocabDocumentTagsData)
      .subscribe(documents => {
        const attachments = this.attachmentProcessorService.processAttachmentsFromDocuments(documents);
        this.requestDocuments = attachments;
        this.attachmentProcessorService.setRequestDocuments(this.requestDocuments);
        this.isRequestDocumentsLoading = false;
        if (this.formData) {
          this.initializeFormData();
        }
        this.setupValidation();
      });
  }

  initializeFormData() {
    if (this.formData?.records) {
      this.records.clear();
      _.forEach(this.formData.records, (record, index) => {
        this.attachmentProcessorService.getAttachments(record, index, this.requestDocuments);
        this.records.push(this.createRecordsFormGroup(record));
      });
    }
  }

  getSortedDiagnosticList(list: any): { name: string, code: string }[] {
    return list.sort((a: any, b: any) => {
      const indexA = this.typesOfImagingInExpectedOrder.indexOf(a.code);
      const indexB = this.typesOfImagingInExpectedOrder.indexOf(b.code);
      if (a.key === "other") return 1;
      if (b.key === "other") return -1;

      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return 0;
    });
  }

  /**
   * Creates a new records form group with various form controls and validators.
   * @param item Optional initial data to populate the form.
   * @returns The form group instance.
   */
  createRecordsFormGroup(item?: any, isSplit:boolean = false): FormGroup {
    return new FormGroup({
      'providerName': new CustomFormControl(item?.providerName || '', 'Provider (Institution)', [Validators.required]),
      'providerKeys': new FormControl(isSplit ? null : item?.providerKeys || null),
      'doctorKeys': new FormControl(isSplit ? null : item?.doctorKeys || null),
      'doctor': new FormControl(item?.doctor || ''),
      'streetAddress': new FormControl(item?.streetAddress || ''),
      'aptSuiteOther': new FormControl(item?.aptSuiteOther || ''),
      'cityName': new FormControl(item?.cityName || ''),
      'stateName': new FormControl(item?.stateName || ''),
      'zipCode': new FormControl(item?.zipCode || ''),
      'email': new CustomFormControl(item?.email || '', 'Email', [Validators.email]),
      'phone': new FormControl(item ? item?.phone : null),
      'extn': new FormControl(item ? item?.extn : null),
      'fax': new FormControl(item?.fax || ''),
      'subject': new CustomFormControl((item ? item?.subject : (this.subjectNames.length == 1 ? this.subjectNames[0] : null)), 'Record Subject', [Validators.required]),
      'range': new FormControl(item?.range || ['anyorall']),
      'dateToServiceFrom': new CustomFormControl(item?.dateToServiceFrom || '', 'Date to service from', []),
      'dateToServiceTo': new CustomFormControl(item?.dateToServiceTo || '', 'Date to service to', []),
      'medical': new FormControl(item?.medical || ''),
      'billing': new FormControl(item?.billing || ''),
      'dental': new FormControl(item?.dental || ''),
      'educational': new FormControl(item?.educational || ''),
      'employment': new FormGroup({
        'employmentSS': new CustomFormControl(item?.employment?.employmentSS || '', 'Employment SS#'),
      }),
      'irs': new FormGroup({
        'irsSS': new CustomFormControl(item?.irs?.irsSS || '', 'IRS SS#'),
      }),
      'mentalHealth': new FormControl(item?.mentalHealth || ''),
      'pharmacy': new FormControl(item?.pharmacy || ''),
      'union': new FormGroup({
        'membershipNumber': new FormControl(item?.union?.membershipNumber || ''),
      }),
      'other': new FormGroup({
        'descriptionOfRecords': new CustomFormControl(item?.other?.descriptionOfRecords || '', 'Description of Records'),
      }),
      'subpoenaLanguageTextarea': new FormControl(item?.subpoenaLanguageTextarea || ''),
      'notesTextarea': new FormControl(item?.notesTextarea || ''),
      'diagnosticImages': new FormGroup({
        'typesOfImaging': new FormControl(item?.diagnosticImages?.typesOfImaging || []),
        'other': new FormControl(item?.diagnosticImages?.other || ''),
        'specificBodyPart': new FormControl(item?.diagnosticImages?.specificBodyPart || '')
      }),
      'ambulance': new FormGroup({
        'date': new CustomFormControl(item?.ambulance?.date || '', 'Date of Ambulance Service'),
        'time': new FormControl(item?.ambulance?.time || ''),
        'pickupAddress': new FormControl(item?.ambulance?.pickupAddress || ''),
        'pickupCity': new FormControl(item?.ambulance?.pickupCity || ''),
        'pickupState': new FormControl(item?.ambulance?.pickupState || ''),
        'pickupZip': new FormControl(item?.ambulance?.pickupZip || ''),
        'dropAddress': new FormControl(item?.ambulance?.dropAddress || ''),
        'dropCity': new FormControl(item?.ambulance?.dropCity || ''),
        'dropState': new FormControl(item?.ambulance?.dropState || ''),
        'dropZip': new FormControl(item?.ambulance?.dropZip || '')
      }),
      'socialSecurity': new FormGroup({
        'socialSecuritySS': new CustomFormControl(item?.socialSecurity?.socialSecuritySS || '', 'Social Security SS#'),
        'address': new CustomFormControl(item?.socialSecurity?.address || '', 'Social Security Street Address'),
        'city': new CustomFormControl(item?.socialSecurity?.city || '', 'Social Security City'),
        'state': new CustomFormControl(item?.socialSecurity?.state || '', 'Social Security State'),
        'zip': new CustomFormControl(item?.socialSecurity?.zip || '', 'Social Security Zip')
      }),
      'insurance': new FormGroup({
        'claimNumber': new CustomFormControl(item?.insurance?.claimNumber || '', 'Insurance Claim Number'),
        'policyNumber': new FormControl(item?.insurance?.policyNumber || '')
      }),
      'military': new FormGroup({
        'branch': new FormControl(item?.military?.branch || ''),
        'serviceNumber': new FormControl(item?.military?.serviceNumber || '')
      }),
      'va': new FormGroup({
        'medical': new FormControl(item?.va?.medical || ''),
        'benefit': new FormControl(item?.va?.benefit || '')
      }),
      'selectedTypes': new CustomFormControl(item?.selectedTypes || [], 'Requested record types', [Validators.required]),
      'isNew': new FormControl(item ? item.isNew : true),
      'requestNumber': new FormControl(isSplit ? null : item?.requestNumber ?? item?.requestNumbers?.[0] ?? null),
      // Request splitting - UUID is generated once at form creation time (never at submit time)
      'requestUuid': new FormControl(item?.requestUuid || this.createUuidService.generateRequestUuid()),
      // Parent reference for split children - set only when this request is split from another
      'parentRequestNumber': new FormControl(item?.parentRequestNumber || null),
      'orderInfoAttachmentFile': new CustomFormControl(isSplit ? (item?.orderInfoAttachmentFile ?? []).map((f: any) => ({ ...f, isNew: true })) : item?.orderInfoAttachmentFile || [], 'Attachments'),
      'orderInfoAttachmentLabel': new CustomFormControl(item?.orderInfoAttachmentLabel || '', 'Label'),
      'orderInfoAttachmentExplanation': new CustomFormControl(item?.orderInfoAttachmentExplanation || '', 'Attachment Description'),
      //'isEditMode': new FormControl(item?.isEditMode || false)
    });
  }

  /**
   * Disables specific form groups in the records form array.
   * @param i The index of the record to disable.
   */
  disableFormGroups(i: number): void {
    const recordsGroup = (this.recordsFormGroup.get('records') as FormArray).at(i);
    recordsGroup.get('socialSecurity')?.disable();
    recordsGroup.get('ambulance')?.disable();
    recordsGroup.get('insurance')?.disable();
    recordsGroup.get('other')?.disable();
    recordsGroup.get('diagnosticImages')?.disable();
    recordsGroup.get('employment')?.disable();
    recordsGroup.get('union')?.disable();
    recordsGroup.get('irs')?.disable();
  }

  /**
   * Adds a new record to the records form array and validates the form.
   */
  addNewRecord(): void {
    this.records.controls.forEach((record: any,index) => {
      record.controls['selectedTypes'].patchValue( record.controls['selectedTypes'].value);
    });
    this.setupValidation();
    this.validateForm();
    if (this.recordsFormGroup.valid) {
      this.selectedRecordTypes = [];
      // this.records.controls.forEach((record: any) => {
      //   record.controls['isEditMode'].patchValue(false);
      // });
      const recordIndex = this.records.length + 1;
      this.records.push(this.createRecordsFormGroup());
      this.requestDocuments.push({
          requestNumber: String(recordIndex),
          documentList: []
        });
      this.attachmentProcessorService.setRequestDocuments(this.requestDocuments);
      this.setupValidation();
      this.disableFormGroups(this.records.length - 1);

      // add focus to newly added record
      this.cdr.detectChanges();
      setTimeout(() => {
        const headersArray = this.recordsHeaders.toArray();
        const newHeader = headersArray[headersArray.length - 1];
        newHeader.nativeElement.focus();
      });
    } else {
      this.recordsFormGroup.markAllAsTouched();
      this.addProviderValidate.emit();
    }
  }

    // hideReadOnlyFields(key: string, value: string) {
    //   const fieldsToHide = ['other', 'specificBodyPart'];
    //  return !(fieldsToHide.includes(key) && !value) && (key !== 'typesOfImaging');
    // }

    // isSpecialCase(controlName: string): boolean {
    //   return this.getDisplayName(controlName) === 'Ambulance' || this.getDisplayName(controlName) === 'Social Security' || this.getDisplayName(controlName) === 'VA';
    // }

  /**
   * Removes a record from the records form array.
   * @param index The index of the record to remove.
   */
  removeRecord(index: number) {
    this.showDeleteModal = true;
    this.itemToDelete = index;
  }

  /**
   * Deletes the selected record from the form array.
   */
  delete() {
    this.records.removeAt(this.itemToDelete);
    const requestNumber = this.itemToDelete + 1;
    this.requestDocuments = this.requestDocuments.filter(doc => doc.requestNumber !== requestNumber);
    this.attachmentProcessorService.setRequestDocuments(this.requestDocuments);
    this.itemToDelete = null;
    this.showDeleteModal = false;
    this.messageService.add({
        severity: 'success',
        summary: 'SUCCESS',
        detail: `Provider successfully deleted.`,
        life: 3000,
      });
  }

  splitRequest(recordIndex: any) {
    const recordToSplit = this.records.at(recordIndex);
    if(recordToSplit.valid) {
      const requestNumber: string = recordToSplit.get('requestNumber')?.value;
      const requestUuid: string = recordToSplit.get('requestUuid')?.value;
      const parentRef: string = requestNumber
        ? requestNumber.split('-')[0]
        : requestUuid;

      _.forEach(recordToSplit?.value?.selectedTypes?.slice(1), (item, index:number) => {
        let newRecordValue = _.cloneDeep(recordToSplit.value);
        newRecordValue.selectedTypes = [item];
        newRecordValue.isNew = true;

        // Tag the child with its parent reference for backend linking
        newRecordValue.parentRequestNumber = parentRef;
        newRecordValue.requestNumber = undefined;
        newRecordValue.requestUuid = undefined;
        // Child gets its own NEW UUID via createRecordsFormGroup() - no manual assignment needed
        // The requestUuid FormControl will auto-generate a fresh UUID since newRecordValue.requestUuid is not set
        this.records.push(this.createRecordsFormGroup(newRecordValue, true));
        this.requestDocuments.push({
          requestNumber: String(this.records.length),
          documentList: recordToSplit.get('orderInfoAttachmentFile')?.value.flat() || []
        });
        this.attachmentProcessorService.setRequestDocuments(this.requestDocuments);
      });
      recordToSplit.get('selectedTypes')?.setValue([recordToSplit?.value?.selectedTypes.at(0)]);
      this.messageService.add({
        severity: 'success',
        summary: 'SUCCESS',
        detail: `Request successfully splitted.`,
        life: 3000,
      });
    }
  }


  // isObject(value: any): boolean {
  //   return typeof value === 'object' && value !== null;
  // }

  // getSelectedRequestTypes(record: any) {
  //   const filteredNamesString = this.requestedRecordTypes
  //     .filter(type => record.controls['selectedTypes'].value.includes(type.key))
  //     .map(record => record.name)
  //     .join(', ');
  //   return filteredNamesString
  // }

  getDisplayListOfTypesOfImaging(typesOfImaging: any) {
    const filteredNamesString = typesOfImaging
      .map((type: any) => type.name)
      .join(', ');
    return filteredNamesString
  }

  // isControlIncluded(record: any, controlName: string) {
  //   let displayName = controlName;
  //   if (controlName === 'diagnosticImages') displayName = 'diagnostic-images';
  //   if (controlName === 'socialSecurity') displayName = 'social-security';

  //   return record.value.selectedTypes.includes(displayName);
  // }
  // /**
  //  * Enables the edit mode for a selected record.
  //  * @param record The record to edit.
  //  * @param index The index of the record in the form array.
  //  */
  // editRecord(record: any, index: number) {
  //   this.records.controls.forEach((record: any) => {
  //     record.controls['isEditMode'].patchValue(false);
  //   });
  //   record.controls['isEditMode'].patchValue(true);
  // }

  /**
   * Checks if the form control has an error and should be highlighted.
   * @param controlId The ID of the form control to check.
   * @param record Optional record for nested form controls.
   * @returns True if the form control is invalid and touched or dirty.
   */
  isError(controlId: string, record?: any): boolean {
    let formControl = this.recordsFormGroup.get(controlId);
    if (record) {
      formControl = record.get(controlId);
    }
    if (formControl) {
      return formControl.invalid && (formControl.dirty || formControl.touched);
    }
    return false;
  }

  /**
   * Handles the selection of a requested record type.
   * @param event The selection event.
   * @param selectedRecordTypes The record type being selected.
   * @param record The current record.
   */
  onSelectRequestedRecord(event: any, selectedRecordType: string, record: any) {
    if (event.originalEvent.target.checked) {
      this.selectedRecordTypes.push(selectedRecordType);
      if (selectedRecordType === 'Diagnostic Images') this.toggleAllImagingTypes(record);

    } else {
      this.selectedRecordTypes = this.selectedRecordTypes.filter(selectedRecord => selectedRecordType !== selectedRecord);
      record.controls[this.getKeyByName(selectedRecordType)].disable();
    }
    if (['Social Security', 'Employment', 'IRS'].includes(selectedRecordType)) {
      this.syncRecordFieldsAndSSN(selectedRecordType);
    }
    // for record page
    this.setupValidation();
    this.validateForm();
  }

  onRecordSubjectChange(recordControl:any, index:number){
    const subject = recordControl.get('subject')?.value;
      this.records.controls.forEach((otherRecordControl, otherIndex) => {
        if (index !== otherIndex) {
          const otherSubject = otherRecordControl.get('subject')?.value;
          if (subject === otherSubject) {
            const employmentSS = otherRecordControl.get('employment.employmentSS')?.value;
            const irsSS = otherRecordControl.get('irs.irsSS')?.value;
            const socialSecuritySS = otherRecordControl.get('socialSecurity.socialSecuritySS')?.value;

            const selectedValue = employmentSS || irsSS || socialSecuritySS;

            if (selectedValue) {
              recordControl.get('employment.employmentSS')?.setValue(selectedValue);
              recordControl.get('irs.irsSS')?.setValue(selectedValue);
              recordControl.get('socialSecurity.socialSecuritySS')?.setValue(selectedValue);
            }
          }
        }
      });
  }

  syncRecordFieldsAndSSN(selectedRecordType: string) {
    this.records.controls.forEach((recordControl, index) => {
      const subject = recordControl.get('subject')?.value;
      this.records.controls.forEach((otherRecordControl, otherIndex) => {
        if (index !== otherIndex) {
          const otherSubject = otherRecordControl.get('subject')?.value;
          if (subject === otherSubject) {
            this.syncSSNFormValues(recordControl, otherRecordControl);
          }
        }
      });
      this.syncSSNFormValues(recordControl,undefined, selectedRecordType);
    });
  }

  // Method to sync SSN form values (employmentSS, irsSS, socialSecuritySS)
  syncSSNFormValues(record: any, existingRecord?: any, selectedRecordType?:string) {
    const employmentSS = record.get('employment.employmentSS')?.value;
    const irsSS = record.get('irs.irsSS')?.value;
    const socialSecuritySS = record.get('socialSecurity.socialSecuritySS')?.value;

    const val = employmentSS || irsSS || socialSecuritySS;
    if (selectedRecordType === 'Employment') {
       record.get('employment.employmentSS').setValue(val);
    }

    else if (selectedRecordType === 'Social Security') {
       record.get('socialSecurity.socialSecuritySS').setValue(val);
    }
    else if (selectedRecordType === 'IRS') {
      record.get('irs.irsSS').setValue(val);
    }

    if (existingRecord) {
      const existingEmploymentSS = existingRecord.get('employment.employmentSS')?.value;
      const existingIrsSS = existingRecord.get('irs.irsSS')?.value;
      const existingSocialSecuritySS = existingRecord.get('socialSecurity.socialSecuritySS')?.value;

      if (employmentSS && !existingEmploymentSS) {
        existingRecord.get('employment.employmentSS')?.setValue(employmentSS);
      }

      if (irsSS && !existingIrsSS) {
        existingRecord.get('irs.irsSS')?.setValue(irsSS);
      }

      if (socialSecuritySS && !existingSocialSecuritySS) {
        existingRecord.get('socialSecurity.socialSecuritySS')?.setValue(socialSecuritySS);
      }
    }
  }

  /**
   * Creates a new form group for social security details.
   * @returns The social security form group.
   */
  createSocialSecurity(): FormGroup {
    return new FormGroup({
      'socialSecuritySS': new CustomFormControl('', 'Social Security SS#', [Validators.required]),
      'address': new CustomFormControl('', 'Social Security Street Address', [Validators.required]),
      'city': new CustomFormControl('', 'Social Security City', [Validators.required]),
      'state': new CustomFormControl('', 'Social Security State', [Validators.required]),
      'zip': new CustomFormControl('', 'Social Security Zip', [Validators.required])
    });
  }

  /**
   * Returns the keys of an object.
   * @returns The keys of the object.
   */
  // get objectKeys() {
  //   return Object.keys;
  // }

  // /**
  //  * Retrieves the display name for a specific record type.
  //  * @param key The key of the record type.
  //  * @returns The corresponding display name.
  //  */
  // getDisplayName(key: string): string {
  //   const item = this.displayNames.find(entry => entry.key === key);
  //   return item ? item.name : '';
  // }

  /**
   * Checks if the "Other" imaging type is selected for the record.
   * @param record The record to check.
   * @returns True if the "Other" imaging type is selected.
   */
  isOtherImagingTypeSelected(record: any): boolean {
    const typesOfImaging = record.controls['diagnosticImages']?.controls['typesOfImaging'].value || [];
    const isOtherImaging = typesOfImaging.some((type: any) => type.code === 'other' && type.name === 'Other');

    return isOtherImaging;
  }

  onTypeChange(record: any, type: any, event: any) {
    const selectedTypes: any[] = [...record.controls['diagnosticImages']?.controls['typesOfImaging'].value];
    record.get('diagnosticImages.typesOfImaging')?.setValue(selectedTypes);
    const isOtherImaging = record.controls['diagnosticImages']?.controls['typesOfImaging'].value.some((type: any) => type.code === 'other' && type.name === 'Other');

    isOtherImaging ? record.get('diagnosticImages').addControl('other', new FormControl('', Validators.required)) : record.get('diagnosticImages').removeControl('other');
  }

  /**
   * Toggles the selection of all imaging types based on specific conditions.
   * @param record The record to toggle imaging types for.
   */
  toggleAllImagingTypes(record: any) {
    const selectedValue = record.get('range')?.value.includes('anyorall');
    if (selectedValue) {
      let selectedType = this.typesOfImaging.filter(type => type.name === 'X-Rays')
      if (record.get('diagnosticImages')) {
        record.get('diagnosticImages.typesOfImaging')?.setValue(selectedType);
      }
      this.resetDateValidators(record, false);
    } else {
      record.get('diagnosticImages.typesOfImaging')?.setValue([]);
      this.resetDateValidators(record, true);
    }
  }

  resetDateValidators(record: any, isSelected: boolean) {
    if(isSelected) {
      record.get('dateToServiceFrom')?.setValidators([Validators.required]);
      record.get('dateToServiceTo')?.setValidators([Validators.required, this.dateValidator.bind(record)]);
    } else {
      record.get('dateToServiceFrom')?.clearValidators();
      record.get('dateToServiceTo')?.clearValidators();
    }
    record.get('dateToServiceFrom')?.updateValueAndValidity();
    record.get('dateToServiceTo')?.updateValueAndValidity();
  }

  dateValidator(formGroup: any) {

    if(formGroup && formGroup.parent) {
      const fromDate = formGroup.parent.get('dateToServiceFrom')?.value;
      const toDate = formGroup.parent?.get('dateToServiceTo')?.value;

      if (fromDate && toDate ) {
        if(new Date(toDate) < new Date(fromDate))
          return { 'invalidDateRange': true };
      }
    }
    return null;
  }

  /**
   * Determines the CSS class for the record based on its edit mode.
   * @param record The record to check.
   * @param i The index of the record.
   * @returns The CSS class name.
   */
  // isReadOnly(record: any, i: any): string {
  //   if (this.records.length > 1 && i < (this.records.length - 1) && !record.value.isEditMode) {
  //     return 'panel-without-bg-color';
  //   } else {
  //     return 'panel-bg-color';
  //   }
  // }

  /**
   * Determines whether to show additional details for a record based on its selected types.
   * @param record The record to check.
   * @returns True if additional details should be shown.
   */
  showAdditionalDetails(record: any): boolean {
    return this.fieldsForAdditionalDetails.filter(type => record.controls['selectedTypes'].value.includes(type)).length > 0;
  }

  /**
   * Checks if a specific record type is selected and toggles the visibility of its corresponding field.
   * @param record The record to check.
   * @param type The record type to check.
   * @returns True if the record type is selected.
   */
  checkRecordType(record: any, type: any) {
    const selectedType = record.controls['selectedTypes'].value.includes(type);
    const typeMap: { [key: string]: string } = {
      'diagnostic-images': 'diagnosticImages',
      'social-security': 'socialSecurity',
    };
    const mappedType = typeMap[type] || type;
    const control = record.get(mappedType);
    if (control) {
      const isControlCurrentlyEnabled = !control.disabled;
      if (isControlCurrentlyEnabled !== selectedType) {
        this.toggleFieldVisibility(selectedType, control);
      }
    }
    // this.setupValidation();
    return selectedType;
  }

  /**
   * Toggles the visibility of a field based on its selected state.
   * @param isVisible True to enable the field, false to disable it.
   * @param control The form control to toggle.
   */
  toggleFieldVisibility(isVisible: boolean, control: any) {
    if (control) {
      if (isVisible) {
        control.enable();
      } else {
        control.disable();
      }
    }
  }

  /**
   * Validates the entire form and marks all controls as touched and dirty.
   */
  validateForm(): void {
    Object.keys(this.recordsFormGroup.controls).forEach(controlName => {
      const control = this.recordsFormGroup.get(controlName);
      if (control instanceof FormGroup) {
        this.validateNestedFormGroup(control);
      } else {
        control?.markAsTouched();
        control?.markAsDirty();
      }
    });
  }

  /**
   * Validates a nested form group recursively.
   * @param formGroup The nested form group to validate.
   */
  validateNestedFormGroup(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.get(controlName);
      if (control instanceof FormGroup) {
        this.validateNestedFormGroup(control);
      } else {
        control?.markAsTouched();
        control?.markAsDirty();
      }
    });
  }

  /**
   * Constructs the complete address from the given record.
   * @param record The record to generate the address from.
   * @returns The full address as a string.
   */

  // getCompleteAddress(address: string, city: string, state: any, zip: string): string {
  //   const stateName = state ? state : { name: '', value: '' };
  //   const completeAddress = `${address || ''} ${city || ''} ${stateName.name || ''} ${zip || ''}`.trim();
  //   return completeAddress ? completeAddress : '--';
  // }

  getKeyByName(name: string): string {
    const item = this.displayNames.find(entry => entry.name === name);
    return item ? item.key : '';
  }

  setupValidation() {
    const recordsArray = this.recordsFormGroup.get('records') as FormArray;
    if (!recordsArray) {
      console.error("records FormArray is undefined");
      return;
    }
    recordsArray.controls.forEach((recordGroup, index) => {
      const group = recordGroup as FormGroup;
      group.get('dateToServiceFrom')?.valueChanges.subscribe(() => {
        group.get('dateToServiceTo')?.updateValueAndValidity();
      });
      const selectedTypesControl = group.get('selectedTypes');
      if (!selectedTypesControl) {
        console.error(`selectedTypes not found for record at index ${index}`);
        return;
      }
      selectedTypesControl.valueChanges.subscribe((selectedTypes: string[]) => {
        const groupsToValidate: any = {
          'socialSecurity': ['socialSecuritySS', 'address', 'city', 'state'],
          'ambulance': ['date'],
          'insurance': ['claimNumber'],
          'other': ['descriptionOfRecords'],
          'employment': ['employmentSS'],
          'irs': ['irsSS']
        };

        Object.keys(groupsToValidate).forEach(groupKey => {
          const fieldGroup = group.get(groupKey) as FormGroup;
          if (!fieldGroup) return;
          groupsToValidate[groupKey].forEach((field: any) => {
            const typeMap: { [key: string]: string } = {
              'diagnosticImages': 'diagnostic-images',
              'socialSecurity': 'social-security',
            };
            const mappedType = typeMap[groupKey] || groupKey;
            const control = fieldGroup.get(field);
            if (control) {
              if (selectedTypes.includes(mappedType)) {
                control.addValidators(Validators.required);
                // Mark as touched/dirty so error shows immediately
                //control.markAsTouched();
                //control.markAsDirty();
              } else {
                control.clearValidators();
                control.markAsUntouched();
                control.markAsPristine();
              }
              control.updateValueAndValidity();
            }
          });
        });
      });
    });
  }

  sortRecordsInExpectedOrder() {
    this.requestedRecordTypes.sort((a, b) => {
      const indexA = this.recordTypesInExpectedOrder.indexOf(a.key);
      const indexB = this.recordTypesInExpectedOrder.indexOf(b.key);

      // If key is "other", always push it to the end
      if (a.key === "other") return 1;
      if (b.key === "other") return -1;

      // If both keys are in the expected order, sort accordingly
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      // If only one of them is in expectedOrder, prioritize it
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;

      // If neither are in expectedOrder, maintain their relative order
      return 0;
    });
  }

  checkSubjectMismatchError(subject: string):boolean {
    const ssnSubjectMismatch = this.recordsFormGroup.errors?.['ssnSubjectMismatch'];
    return ssnSubjectMismatch && ssnSubjectMismatch.includes(subject);
  }

  onDateChange(event: any, index: number, dateType: string) {
    const rawValue = event;
    const inputDate = new Date(rawValue);
    const recordsFormGroup = (this.recordsFormGroup.get('records') as FormArray).at(index);

    const selectedValue = recordsFormGroup.get('range')?.value.includes('anyorall');
    if (selectedValue) {
      this.resetDateValidators(recordsFormGroup, false);
    } else {
      this.resetDateValidators(recordsFormGroup, true);
    }

    if (!isNaN(inputDate.getTime()) && inputDate > this.maxDate) {
      if (dateType === 'serviceFromDate') {
        recordsFormGroup.get('dateToServiceFrom')?.setErrors({ maxDateExceeded: true });
      } else if(dateType === 'serviceToDate'){
        recordsFormGroup.get('dateToServiceTo')?.setErrors({ maxDateExceeded: true });
      } else {
        (recordsFormGroup.get('ambulance') as FormGroup)
        ?.get('date')
        ?.setErrors({ maxDateExceeded: true });
      }
    }
  }

  onContactSelect(contact: ContactItem, index: number) {
    const recordsGroup = (this.recordsFormGroup.get('records') as FormArray).at(index);
    if (!recordsGroup || !contact) return;

    // Patch provider name
    if (contact.party?.displayName) {
      recordsGroup.get('providerName')?.setValue(contact.party.displayName);
    }

    // Patch doctor - find medical-provider role similar to document-processor.service.ts
    const doctorName = contact.party?.names?.find((n: PartyName) => n.function === 'medical-provider')?.text;
    if (doctorName) {
      recordsGroup.get('doctor')?.setValue(doctorName);
    }

    // Patch address fields
    const locationLocator = contact.party?.locators?.find((l: PartyLocator) => l.typeCode === 'location');
    const address = locationLocator?.location?.location?.usAddress;

    if (address) {
      recordsGroup.get('streetAddress')?.setValue(address.lineOne || '');
      recordsGroup.get('aptSuiteOther')?.setValue(address.lineTwo || '');
      recordsGroup.get('cityName')?.setValue(address.city || '');
      recordsGroup.get('zipCode')?.setValue(address.postalCode || '');

      console.debug('address', address);
      console.debug('states', this.states);
      if (address.stateCode) {
        const matchingState = this.states?.find((s: any) =>
          s.value?.toUpperCase() === address.stateCode?.toUpperCase()
        );
        if (matchingState) {
          recordsGroup.get('stateName')?.setValue(matchingState);
        }
      }
    }

    // Patch phone fields - phone may already be formatted
    const phoneLocator = contact.party?.locators?.find((l: PartyLocator) => l.typeCode === 'phone' && l.phone?.purpose == 'work');
    if (phoneLocator?.phone?.number && phoneLocator.phone.purpose == 'work') {
      recordsGroup.get('phone')?.setValue(phoneLocator.phone.number);
    } else {
      recordsGroup.get('phone')?.setValue('');
    }
    if (phoneLocator?.phone?.extension && phoneLocator.phone.purpose == 'work') {
      recordsGroup.get('extn')?.setValue(phoneLocator.phone.extension);
    } else {
      recordsGroup.get('extn')?.setValue('');
    }

    // Patch fax field
    const faxLocator = contact.party?.locators?.find((l: PartyLocator) => l.typeCode === 'phone' && l.phone?.purpose == 'fax');
    if (faxLocator?.phone?.number && faxLocator.phone.purpose == 'fax') {
      recordsGroup.get('fax')?.setValue(faxLocator.phone.number);
    } else {
      recordsGroup.get('fax')?.setValue('');
    }

    // Patch email field
    const emailLocator = contact.party?.locators?.find((l: PartyLocator) => l.typeCode === 'email');
    if (emailLocator?.email?.address) {
      recordsGroup.get('email')?.setValue(emailLocator.email.address);
    } else {
      recordsGroup.get('email')?.setValue('');
    }

    // Trigger validation after patching values
    recordsGroup.updateValueAndValidity();
  }

}
